export enum LeAbilities {
  can = 'can',
  cannot = 'cannot',
}

export enum LeActions {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
  modify = 'modify',
  access = 'access',
  manage = 'manage',
}

export type LeAbility = LeAbilities.can | LeAbilities.cannot
export type LeAction =
  | LeActions.create
  | LeActions.read
  | LeActions.update
  | LeActions.delete
  | LeActions.modify
  | LeActions.access
  | LeActions.manage
